import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m-1.563-6.875h.938v-2.5h-.938a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h1.874c.52 0 .938.418.938.938v3.437h.313c.519 0 .937.418.937.938a.935.935 0 0 1-.938.937H8.438a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937ZM10 5a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 10 5"
    }, null, -1)
  ])))
}
export default { render: render }